<template>
    <div class="mx-auto container container--fluid">
        <br>
        <v-app id="inspire" class>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <template v-if="load == true">
                <v-data-table :headers="headers" :items="rolelist" sort-by="roletype.name" class="elevation-1 mytable"
                    :search="search" dense>
                    <template v-slot:top>
                        <v-toolbar dense class="toolbar" flat color="white">
                            <v-toolbar-title>Role Details</v-toolbar-title>
                            <v-divider class="mx-4" color="white" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                background-color="white" hide-details></v-text-field>                           
                        </v-toolbar>
                         <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-toolbar dense flat color="white">
                                        <v-toolbar-title><v-btn small class="mb-2 button" v-on="on">New
                                                Role</v-btn></v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>

                                <v-card class="pa-0">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container class="pa-0 pt-5">
                                            <v-row dense>
                                                <v-col cols="12">                                                   
                                                    <v-autocomplete v-model="editedItem.name" label="Role" dense
                                                        :items="role_super_master_list"
                                                        @change="getIcon(editedItem.name)" item-text="name"
                                                        :readonly="editedIndex !== -1" :filled="editedIndex !== -1"
                                                        :hint="editedIndex === -1
                                                            ? 'For example :: Admin, Staff, OfficeStaff etc'
                                                            : 'noneditable'" :error="!!errorMsg.roleName"
                                                        :error-messages="errorMsg.roleName ? 'Required' : ''"
                                                        persistent-hint></v-autocomplete>

                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.sort_order" dense
                                                        hint='Sort Order :: 1,2,3 ' persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <input type="hidden" v-model="editedItem.id" name="id" />
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-select dense v-model="editedItem.roletype" :items="roletype"
                                                        :readonly="editedIndex == -1 ? false : true" item-text="name"
                                                        item-value="id" label="Module" persistent-hint
                                                        :hint="editedIndex == -1 ? 'Select module :: Admission, Account etc' : 'noneditable'"
                                                        :filled="editedIndex == -1 ? false : true" return-object
                                                        single-line :error="errorMsg.roleType ? true : false"
                                                        :error-messages="errorMsg.roleType ? 'Required' : ''"></v-select>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-select dense v-model="editedItem.usertype" :items="usertype"
                                                        :readonly="editedIndex == -1 ? false : true" item-text="name"
                                                        item-value="id" label="User Type" persistent-hint
                                                        :hint="editedIndex == -1 ? 'Select user type :: Teacher, Student etc' : 'noneditable'"
                                                        :filled="editedIndex == -1 ? false : true" return-object
                                                        single-line :error="errorMsg.userType ? true : false"
                                                        :error-messages="errorMsg.userType ? 'Required' : ''">
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="12" v-if="show_icon || editedIndex !== -1 && editedItem.icon!=''">
                                                    <v-text-field readonly filled outlined dense
                                                        v-model="editedItem.icon"></v-text-field>
                                                    <center><v-img v-if="editedItem.icon" width="30" height="30"
                                                            :src="editedItem.icon"></v-img></center>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="button" @click="close">Cancel</v-btn>
                                        <v-btn class="button" @click="save">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        <span style="width: 20px;"> </span>
                    </template>
                    <template v-slot:item.isactive="{ item }">
                        <span v-if="item.isactive">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-avatar style="" size="25" class="edit-avatar">
                                    <v-icon class="edit-v-icon mr-2" @click="editItem(item)" title="edit" style="">
                                        edit
                                    </v-icon>
                                </v-avatar>
                            </template>
                            <span>edit</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </template>
        </v-app>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        isallowed: false,
        errorMsg: {
            userType: false,
            roleName: false,

            roleType: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        temp: {},
        load: false,
        dialog: false,
        roletype: {},
        rolelist: {},
        usertype: {},
        role_super_master_list: [],       
        show_icon: false,
        headers: [
            { text: "Role", value: "name" },
            { text: "Module", value: "roletype.name" },
            { text: "User Type", value: "usertype.name" },
            { text: "Created By", value: "creation_username" },
            { text: "Created On", value: "creation_date" },
            { text: "Sort Order", value: "sort_order" },
            { text: "Active", value: "isactive" },
            { text: "Actions", value: "action", sortable: false },
        ],

        editedIndex: -1,
        editedItem: {
            name: "",
            id: "",
            sort_order: "",
            isactive: false,
            icon:"",
            roletype: {
                id: "",
                name: "",
            },
            usertype: {
                id: "",
                name: "",
            },
        },
        defaultItem: {
            name: "",
            id: "",
            sort_order: "",
            isactive: false,
            icon:"",
            roletype: {
                id: "",
                name: "",
            },
            usertype: {
                id: "",
                name: "",
            },
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Role" : "Edit Role";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },
    mounted() {
        this.onload();
    },

    methods: {
        onload() {
            axios
                .post("/roleManagement/addrole")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.rolelist = res.data.rolelist;
                        this.roletype = res.data.roletype;
                        this.usertype = res.data.usertype;
                        this.role_super_master_list = res.data.role_super_master_list;
                        this.load = true;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        this.isallowed = res.data.isallowed;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        getIcon(role) {
            const data = {
                role: role
            }
            axios
                .post("/roleManagement/getIconByRole", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.editedItem.icon = res.data.icon;
                        this.show_icon = true;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });


        },
        initializeErrorMsgFalse() {
            this.errorMsg.roleName = false;
            this.errorMsg.userType = false;
            this.errorMsg.roleType = false;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        editItem(item) {
            this.editedIndex = this.rolelist.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            const index = this.rolelist.indexOf(item);
            confirm("Are you sure you want to delete this item?") && this.rolelist.splice(index, 1);
        },

        close() {
            this.dialog = false;
            this.icon = "";
            this.show_icon = false;
            this.initializeErrorMsgFalse();
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            this.initializeErrorMsgFalse();

            if (this.editedIndex > -1) {
                //  console.log("edit.." + this.editedItem);
                if (this.isValidated()) {
                    this.temp = this.editedItem;
                    axios
                        .post("/roleManagement/editrole", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                Object.assign(this.rolelist[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "Role Updated Successfully..."); // show snackbar on success
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            } else {
                if (this.isValidated()) {
                    axios
                        .post("/roleManagement/addnewrole", this.editedItem)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.rolelist.push(this.editedItem);
                                this.showSnackbar("#4caf50", "New Role Added Successfully..."); // show snackbar on success
                                this.onload();
                            } else if (res.data.flag == "No") {
                                this.showSnackbar("red", "Role Already Added...");

                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            }
        },

        isValidated() {
            // alert('I am in isValidated()'+this.editedItem.name +"||" +this.editedItem.usertype.id +"||"+this.editedItem.roletype.id)
            if (this.editedItem.name && this.editedItem.usertype.id && this.editedItem.roletype.id) {
                return true;
            } else {
                if (!this.editedItem.name) {
                    this.errorMsg.roleName = true;
                }
                if (!this.editedItem.usertype.id) {
                    this.errorMsg.userType = true;
                }
                if (!this.editedItem.roletype.id) {
                    this.errorMsg.roleType = true;
                }
                return false;
            }
        }, // .....end of isValidated()
    },
};
</script>
<style scoped>
</style>
